import { render } from "./ContactBlock.vue?vue&type=template&id=1dacbec2&scoped=true"
const script = {}

import "./ContactBlock.vue?vue&type=style&index=0&id=1dacbec2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dacbec2"]])

export default __exports__